import {
    AppliedBillableConceptEntityType,
    AppliedBillableConceptResponse,
    SumPerAccountingUnitResponse
} from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { billingAppliedBillableConceptService } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { CommonDatasourceValuableConceptsModal } from '@/components/valuable-concepts-modal/datasource/valuable-concepts-modal-datasource'
import { ValuableConceptsTreeNode } from '@/components/valuable-concepts-modal/valuable-concepts-modal-tree/valuable-concepts-modal-tree.model'
import i18n from '@/lang/i18n'
import { AgGridColumnType, AgGridExportType, ExportedColDef } from '@/shared/models/ag-grid.model'
import { CrudModelPaginatorLaboratory, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export const valuableConceptsModalGridColumnsDef =
    (): ExportedColDef[] => [
        {
            type: AgGridColumnType.CUSTOM_CHECKBOX,
            exportType: AgGridExportType.BOOLEAN
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.elementID'),
            field: 'entityLabel',
            minWidth: 250,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            headerName: i18n.tc('component.valuableConceptsModal.value'),
            field: 'value',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.alias'),
            field: 'alias',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.reference'),
            field: 'referenceCode',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.conceptCode'),
            field: 'concept.code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.concept'),
            field: 'concept.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.client'),
            field: 'customer.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.rate'),
            field: 'rate.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            headerName: i18n.tc('component.valuableConceptsModal.lastModificationDate'),
            field: 'lastModificationDate',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            headerName: i18n.tc('component.valuableConceptsModal.automatic'),
            field: 'automatic',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            headerName: i18n.tc('component.valuableConceptsModal.requiresAuthorization'),
            field: 'requiresAuthorization',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.authorization'),
            field: 'authorizationCode',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            headerName: i18n.tc('component.valuableConceptsModal.authorizationRequested'),
            field: 'authorizationRequested',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.deliveryNoteId'),
            field: 'deliveryNote.label',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            headerName: i18n.tc('component.valuableConceptsModal.doNotBill'),
            field: 'addToInvoice',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.reasonIfNotToAddToInvoice'),
            field: 'reasonIfNotToAddToInvoice',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.operationCode'),
            field: 'autoInvoiceSystemOperationCode',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            headerName: i18n.tc('component.valuableConceptsModal.error'),
            field: 'autoInvoiceSystemInError',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.errorDescription'),
            field: 'autoInvoiceSystemErrorDescription',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            headerName: i18n.tc('component.valuableConceptsModal.user'),
            field: 'lastModificationUser.fullName',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.isCopayment'),
            field: 'isCopayment',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.hasCopayment'),
            field: 'hasCopayments',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.copaymentType'),
            field: 'copaymentType',
            type: AgGridColumnType.BILLING_COPAYMENT_TYPE,
            exportField: 'copaymentType.translatedName',
            exportType: AgGridExportType.TEXT,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ValuableConceptsModalGridState extends CrudModelPaginatorLaboratory<AppliedBillableConceptResponse> {
    service: typeof billingAppliedBillableConceptService
    laboratoryId: number
    selectedNode: StrictNullable<ValuableConceptsTreeNode>
    accountingUnit: StrictNullable<SumPerAccountingUnitResponse>
    caseId: StrictNullable<number>
    loading: boolean
    isBillingModule: boolean
    caseStatus?: StrictNullable<string>
}
export const initialValuableConceptsGridModalState =
    (): ValuableConceptsModalGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.valuableConcepts.modal',
        columnsDef: valuableConceptsModalGridColumnsDef(),
        datasource: new CommonDatasourceValuableConceptsModal(billingAppliedBillableConceptService, store.getters.labId, AppliedBillableConceptEntityType.CASE, 0, 0),
        service: billingAppliedBillableConceptService,
        laboratoryId: store.getters.labId,
        selectedNode: null,
        accountingUnit: null,
        caseId: null,
        loading: true,
        isBillingModule: false,
        caseStatus: null
    })
